export * from './ticket.service';


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/ticket/index.ts